<template>
  <div :class="$style[classes]">
    <wt-paged-table :on-request-data="getWithdrawList" :total-size="totalNumber" :page-size="pageSize" :current-page="currentPage" ref="table"
     layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <template>
      <div :class="$style['table-tip-text']">
        未提现金额总计：<span class="amount-class">{{noWithdrawalsAmountShow}}元</span>；
        <!--如果云账户月小于未提现金额的话，云账户余额显示为红色-->
        云账户可用总额度：<span :class="data.balanceFen<withdrawAmountOfNo?'amount-red':'amount-class'">{{data.total_balance}}元</span>；
        <!-- 银行卡账户可用额度： -->
        <!-- <span :class="data.bankCardBalanceFen<withdrawAmountOfNo?'amount-red':'amount-class'"> -->
          <!-- <span class="amount-class">
          {{data.balance_card_show}}元</span>； -->
        <!-- 微信账户可用额度： -->
        <!-- <span :class="data.wxpayBalanceFen<withdrawAmountOfNo?'amount-red':'amount-class'"> -->
          <!-- <span class="amount-class">
          {{data.balance_wx_show}}元</span> -->
        <!-- 提现账户余额：<span class="amount-class">{{data.balance_show}}元</span>; -->
        <template v-if="selectedAmount">您已勾选的提现记录总金额为：<span class="amount-class">{{selectedAmount}}元</span></template>
        </div>
      <wt-table :list="tableData" :labels="tableLabels" ref="wtTable"  @select="select" :isSelect="true" @select-all="selectAll">
        <template>
          <slot />
        </template>
      </wt-table>
      <div :class="$style['table-tip-text']">
        未提现金额总计：<span class="amount-class">{{noWithdrawalsAmountShow}}元</span>；
        云账户可用总额度：<span :class="data.bankCardBalanceFen<withdrawAmountOfNo?'amount-red':'amount-class'">{{data.total_balance}}元</span>；
        <!-- 银行卡账户可用额度： -->
        <!-- <span :class="data.bankCardBalanceFen<withdrawAmountOfNo?'amount-red':'amount-class'"> -->
          <!-- <span class="amount-class">
          {{data.balance_card_show}}元</span>；
        微信账户可用额度： -->
        <!-- <span :class="data.wxpayBalanceFen<withdrawAmountOfNo?'amount-red':'amount-class'"> -->
          <!-- <span class="amount-class">
          {{data.balance_wx_show}}元</span>； -->
        <!-- 提现账户余额：<span class="amount-class">{{data.balance_show}}元</span>; -->
        <template v-if="selectedAmount">您已勾选的提现记录总金额为：<span class="amount-class">{{selectedAmount}}元</span></template>
        </div>
      </template>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀

const prefixCls = 'pt-withdraw-table'
export default {
  name: 'pt-withdraw-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    data: {
      type: Object
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedAmount: {
      type: [String, Number]
    },
    noWithdrawalsAmountShow: [String, Number],
    withdrawAmountOfNo: [String, Number]
  },
  data () {
    return {
    }
  },
  methods: {
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    getWithdrawList (page, next, size) {
      this.$emit('getWithdrawList', page, next, size)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    clearSelection () {
      this.$refs.wtTable.clearSelection()
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-withdraw-table{
  :global{
    .el-table{
      border-top: 1px solid #edbe81;
       border-bottom: 1px solid #edbe81
    }
  }

  }
.table-tip-text{
  color: #909399;
  text-align: right;
  margin: 10px 0;
  :global{
    .amount-red{
      color: red!important
          }
    .amount-class{
      color: #edbe81
    }
  }
}
</style>
